import { z } from 'zod'

export const schema = z.object({
  cottages: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      description: z.string(),
      url: z.string(),
      averagePrice: z.number(),
      media: z.object({
        url: z.string(),
      }),
      province: z.object({
        name: z.string(),
      }),
      reviews: z.object({
        total: z.number().int(),
        average: z.number(),
      }),
    }),
  ),
})

export type schemaType = z.infer<typeof schema>
